<thera-header-action-button class="announcement-bell" (clicked)="openList()">
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    width="16"
    height="16"
    aria-hidden="true"
  >
    <path d="m3 11 18-5v12L3 14v-3z" />
    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
  </svg>
  <ng-container *ngIf="active$ | async as active">
    <span
      *ngIf="active.length"
      class="announcement-bell-badge"
      aria-hidden="true"
      >{{ active.length }}</span
    >
  </ng-container>
  <span class="announcement-sr-only">{{ text.bellLabel }}</span>
</thera-header-action-button>
